export default "__VITE_ASSET__CikesV8t__"